import { render } from "./TMF2026.vue?vue&type=template&id=bc214a50&scoped=true"
import script from "./TMF2026.vue?vue&type=script&lang=js"
export * from "./TMF2026.vue?vue&type=script&lang=js"

import "./TMF2026.vue?vue&type=style&index=0&id=bc214a50&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc214a50"]])

export default __exports__